import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlockedCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={250}
    height={160}
    fill='none'
    {...props}
  >
    <g filter='url(#blockedCard_svg__a)'>
      <rect
        width={230}
        height={140}
        x={10}
        y={8}
        fill='url(#blockedCard_svg__b)'
        fillOpacity={0.5}
        rx={12}
        shapeRendering='crispEdges'
      />
    </g>
    <defs>
      <pattern id='blockedCard_svg__b' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#blockedCard_svg__c' transform='matrix(.00093 0 0 .00153 0 -.014)' />
      </pattern>
      <filter
        id='blockedCard_svg__a'
        width={250}
        height={160}
        x={0}
        y={0}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_12239_16856' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_12239_16856' result='shape' />
      </filter>
      <image
        xlinkHref='/images/icons/blocked-card-ebd6f976.webp'
        id='blockedCard_svg__c'
        width={1075}
        height={673}
      />
    </defs>
  </svg>
);
export default SvgBlockedCard;
